import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { mapDispatchProps } from "store/store";

const useAppState = (keys: string[] = ['auth', 'brand', 'preferences']) => {
  const selector = (state: any) => {
    const result: any = {};
    for (const key of keys) {
      result[key] = state[key]?.[key] ?? null;
    }
    return result;
  };
  
  const state = useSelector(selector, shallowEqual);
  const actions = mapDispatchProps(useDispatch());
  
  return { state, actions };
};

export default useAppState;
